import React from 'react';
//importing stles
import './Styles/App.scss';
//importing pages
import Nav from './Components/navbar/Nav';
import Home from './Pages/Home';
import Hardware from './Pages/Hardware';
import Software from './Pages/Software'
import AboutUs from './Pages/AboutUs';
import ContactUs from './Pages/ContactUs';
//Import Router
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import FooterSection from './Components/footer/FooterSection';
import ServicesPage from './Pages/ServicesPage';
import HireUs from './Components/hireUs/HireUs';
import Cart from './Pages/Cart';

function App() {
  return (
    <div className="App">
      <Router>
        <Nav />
        <Switch>

          <Route path="/" exact>
            <Home />
            <HireUs />
            <FooterSection />
          </Route>

          <Route path="/services" exact>
            <ServicesPage />
            <HireUs />
            <FooterSection />
          </Route>

          <Route path="/hardware" exact>
            <Hardware />
            <HireUs />
            <FooterSection />
          </Route>

          <Route path="/software" exact>
            <Software />
            <HireUs />
            <FooterSection />
          </Route>

          <Route path="/aboutus" exact>
            <AboutUs />
            <HireUs />
            <FooterSection />
          </Route>

          <Route path="/contactus" exact>
            <ContactUs />
            <FooterSection />
          </Route>

          <Route path="/cart" exact>
            <Cart />
            <FooterSection />
          </Route>

        </Switch>
      </Router>
    </div>
  );
}

export default App;
